export default __webpack_public_path__ + "static/media/GenpactGoogleLogo.5b8d85d3.svg";